module.exports = __webpack_public_path__ + "static/media/lighthouse-optimized.bbf7d837.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/lighthouse-optimized.jpg
// module id = 951
// module chunks = 0